import React, { useState } from "react";
import Title from "./title";

export default function Textarea({
  form,
  label,
  maxLength = 1024,
  name,
  placeholder,
  setForm = () => { },
  style,
  type = "text",
  value,
  required
}) {
  const error = form.errors !== null ? form.errors[name]?.reduce((n, m) => m, []) : null;
  const [count, setCount] = useState(value.length);
  function handleChange(e) {
    setForm({ ...form, [name]: e.target.value });
    setCount(e.target.value.length);
  }
  return (
    <div style={{ position: "relative" }}>
      <Title style={{ textAlign: "left", marginBottom: ".5rem" }}>{label}</Title>
      <textarea
        cols="40"
        maxLength={maxLength}
        name={name}
        placeholder={placeholder}
        required={required}
        rows="10"
        value={value}
        style={{
          backgroundColor: "transparent",
          border: "1px solid rgba(0, 0, 0, 0.23)",
          borderRadius: 6,
          boxShadow: "none",
          outline: "none",
          overflow: "auto",
          resize: "none",
          textTransform: "none"
        }}
        onChange={handleChange}
        aria-label={label}
      />
      <div>{maxLength - count}</div>
      <div
        style={{
          backgroundColor: "rgb(255, 255, 245)",
          bottom: "-.5rem",
          color: "red",
          position: "absolute",
          right: ".5rem"
        }}
      >
        {error}
      </div>
    </div>
  );
}
